import { Products as ProductsSection } from '../components/Products/Products';

export function Products() {
  return (
    <main>
      <ProductsSection />
    </main>
  );
} 